import React from 'react';
import { useSelector } from 'react-redux';
import { getDecisionsState } from '../store/selectors/decisionsSelector';
import Decisions from '../Decisions';
import initContainerData from 'bdata-react-component/lib/store/initContainerData';
import decisionsReducer from '../store/reducers/decisions';

initContainerData.register({
    reducers: {
        decisions: decisionsReducer
    }
});

const routes = [{
    path: '/',
    exact: false,
    routes: []
}];

const DecisionsContainer = (props) => {
    const decisionsState = useSelector(getDecisionsState);

    return (
        <Decisions { ...props } { ...decisionsState } />
    );
};

export default DecisionsContainer;
export { routes };

